import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import api from 'src/axios';

type UpdateCriteriaFromSessionVariables = {
  sessionId: string;
  name: string;
  values: Record<string, string | number>;
};

async function updateCriteriaFromSessionRequest({
  sessionId,
  name,
  values,
}: UpdateCriteriaFromSessionVariables) {
  const { data } = await api.put(
    `/sales-forecasting-sessions/${sessionId}/criteria/${name}`,
    {
      values,
    },
  );

  return data;
}

export const useUpdateCriteriaFromSession = (
  options?: Omit<
    UseMutationOptions<void, Error, UpdateCriteriaFromSessionVariables>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, UpdateCriteriaFromSessionVariables> => {
  return useMutation({
    mutationFn: updateCriteriaFromSessionRequest,
    ...options,
  });
};
